import styled, { css } from "styled-components";
import { NavLink } from "react-router-dom";
import { ReactSVG } from "react-svg";

const wrapperModifiers = {
  userActive: (theme) => css`
    &::before {
      background: ${theme.colors.green};
    }
  `,
  userDisabled: (theme) => css`
    &::before {
      background: red;
    }
  `,
};

export const Topbar = styled.div`
  ${({ theme }) => css`
    height: 6rem;
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99;

    background-color: ${theme.colors.blueThird};

    padding-right: 4rem;
    display: flex;
    justify-content: end;
    align-items: center;

    @media only screen and (max-width: 978px) {
      display: flex;
      justify-content: space-between;
    }

    @media only screen and (min-width: 978px) {
      display: flex;
      justify-content: flex-end;
    }

     @media only screen and (min-width: 1600px) {
      display: flex;
      justify-content: space-between;
     }
  
    }
  `}
`;

export const Wrapper = styled.div`
  ${({ theme, open }) => css`
    position: fixed;
    top: 6rem;
    left: 0;
    width: 28.5rem;
    z-index: 99;
    height: 100%;
    background-color: ${theme.colors.blue};

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    /*  */
    transform: ${open ? "translateX(0px)" : "translateX(-285px)"};
    transition: transform 0.5s ease-in-out;
  `}
  /* navbar lateral */
   @media only screen and (max-width:978px) {
    z-index: 99;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
`;

export const ClosedNavbar = styled.div`
  display: flex;
  justify-content: flex-start;
  padding: 2rem;
  z-index: 999;

  button {
    background-color: transparent;
    border: none;
    font-size: 25px;
    cursor: pointer;
  }
  @media only screen and (min-width: 978px) {
    button {
      display: none;
    }
  }
`;

export const BoxLogo = styled.div`
  ${({ theme }) => css`
    border-bottom: 3px solid ${theme.colors.lineBlue};
    width: 100%;

    display: flex;
    justify-content: center;
    align-items: center;
  `}
`;

export const Image = styled.img`
  width: 80%;
  margin: 1.7rem;

  @media only screen and (max-width: 978px) {
    width: 60%;
  }
`;

export const UserInfos = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;

  /* @media only screen and (max-width: 1600px) {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
  } */

  /* @media only screen and (max-width: 978px) {
    display: flex;
    justify-content: end;
    align-items: center;
  } */
`;

export const UserName = styled.p`
  ${({ theme, status }) => css`
    color: ${theme.colors.white};
    display: flex;
    justify-content: center;
    align-items: flex-start;
    font-size: ${theme.font.sizes.large};

    svg {
      margin-left: 2rem;
      stroke-width: 0.5px;
    }

    span {
      font-weight: bold;
      margin-left: 0.5rem;
    }

    &::before {
      content: "";
      display: block;
      width: 1rem;
      height: 1rem;
      border-radius: 50%;
      transform: translateY(4px);
      margin-right: 13px;
      background: ${theme.colors.green};
    }

    ${!!status && wrapperModifiers[status](theme)};
  `}
`;

export const Nav = styled.div`
  ${({ theme }) => css`
    margin-top: 4.4rem;
    width: 80%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
  `}

  @media only screen and (max-width: 500px) {
    margin-top: 0.2px;
  }

  @media only screen and (max-width: 978px) {
    z-index: 99999;
  }
  /* nav links lateral */
`;

export const NavLinks = styled(NavLink)`
  ${({ theme }) => css`
    color: ${theme.colors.white};
    background-color: ${theme.colors.lineBlue};

    font-family: Roboto;
    font-weight: 500;
    font-size: ${theme.font.sizes.large};

    display: flex;
    justify-content: flex-start;
    align-items: center;

    width: 256px;
    height: 4rem;
    padding: 0 2rem;
    margin: 0.5rem 0;
    border-radius: 8px 0 0 8px;

    ${({ forceIconCorrection }) => {
      if (forceIconCorrection) {
        return (
          "path:nth-child(2n) { fill: currentColor !important; }" +
          " path:nth-child(1) { fill: transparent !important; }"
        );
      }
      return "";
    }}

    @media (min-width: 1600px) {
      height: 5rem;
    }
  `}
`;

export const SvgIcon = styled(ReactSVG)`
  margin: 0;
  margin-right: 2rem;
  transform: translateY(2px);
  width: 2rem;
  fill: red;

  path:nth-child(1n) {
    fill: currentColor;
  }
`;
